import { useEffect } from 'react';
import { useSettings } from '../contexts/SettingsContext';

/**
 * Sets document.title from Admin Settings.
 */
const DocumentTitle = () => {
  const { settings } = useSettings();

  useEffect(() => {
    if (settings?.site_title) {
      document.title = settings.site_title;
    }
  }, [settings?.site_title]);

  return null;
};

export default DocumentTitle;
